import { createFeature, createReducer, on } from '@ngrx/store';
import { EntityState, EntityAdapter, createEntityAdapter } from '@ngrx/entity';
import { InstitutionAuthUser } from './auth-user.model';
import { AuthUserActions } from './auth-user.actions';

export const authUsersFeatureKey = 'authUsers';

export interface State extends EntityState<InstitutionAuthUser> {
  // additional entities state properties
}

export const adapter: EntityAdapter<InstitutionAuthUser> = createEntityAdapter<InstitutionAuthUser>();

export const initialState: State = adapter.getInitialState({
  // additional entity state properties
});

export const reducer = createReducer(
  initialState,
  on(AuthUserActions.addAuthUser,
    (state, action) => adapter.addOne(action.authUser, state)
  ),
  on(AuthUserActions.upsertAuthUser,
    (state, action) => adapter.upsertOne(action.authUser, state)
  ),
  on(AuthUserActions.addAuthUsers,
    (state, action) => adapter.addMany(action.authUsers, state)
  ),
  on(AuthUserActions.upsertAuthUsers,
    (state, action) => adapter.upsertMany(action.authUsers, state)
  ),
  on(AuthUserActions.updateAuthUser,
    (state, action) => adapter.updateOne(action.authUser, state)
  ),
  on(AuthUserActions.updateAuthUsers,
    (state, action) => adapter.updateMany(action.authUsers, state)
  ),
  on(AuthUserActions.deleteAuthUser,
    (state, action) => adapter.removeOne(action.id, state)
  ),
  on(AuthUserActions.deleteAuthUsers,
    (state, action) => adapter.removeMany(action.ids, state)
  ),
  on(AuthUserActions.loadAuthUsers,
    (state, action) => adapter.setAll(action.authUsers, state)
  ),
  on(AuthUserActions.clearAuthUsers,
    state => adapter.removeAll(state)
  ),
);

export const authUsersFeature = createFeature({
  name: authUsersFeatureKey,
  reducer,
  extraSelectors: ({ selectAuthUsersState }) => ({
    ...adapter.getSelectors(selectAuthUsersState)
  }),
});

export const {
  selectIds,
  selectEntities,
  selectAll,
  selectTotal,
} = adapter.getSelectors();
